import { createAppByPlatform } from '@/create-app/createAppIs24';
import { createAuth0Instance } from '@/helpers/Auth/authClient';
import { initDatadogRUM } from '@/helpers/RUMService/RUMService';
import { AppState, FunnelStorageBackupKey, FunnelStorageKey } from '@/store/types';
import App from './AppIs24.vue';

(async () => {
  const { app, router, store } = await createAppByPlatform(App);

  initDatadogRUM();

  const initialState = window.__INITIAL_STATE__ as AppState;
  if (initialState) {
    // Store state will be cleared during server side transition, need to restore it from local storage for funnel
    // We can replace the funnel state here as it will cause the dom on server render is different from the client render and an issue on vue runtime
    // The solution here is: put a backup local storage key for funnel state, and restore it when the client render
    window.localStorage.setItem(
      FunnelStorageBackupKey,
      window.localStorage?.getItem(FunnelStorageKey) ?? '',
    );

    store.replaceState(initialState);
  }

  const auth0 = createAuth0Instance();
  if (auth0) {
    app.use(auth0 as any);
  }

  await router.isReady();
  app.mount('#app');
})();
